/**
 * Dark adaptation after moving from a bright place into the dark (expert feedback on retinitis pigmentosa, D-023).
 * Visibility 0..1 is relative to a fully adapted healthy eye; the renderer turns it into brightness, lost faint
 * detail and faded colour. Time-lapse: DARK_DEMO_MINUTES of adaptation are shown in DARK_DEMO_SECONDS.
 */

export const DARK_DEMO_MINUTES = 30;
export const DARK_DEMO_SECONDS = 15;

/** Healthy eye: a fast cone phase over the first minutes and a slower rod phase to ~30 min. */
export function healthyVisibility(tMin: number): number {
  const t = Math.max(0, tMin);
  return 1 - 0.85 * (0.45 * Math.exp(-t / 1.2) + 0.55 * Math.exp(-t / 7));
}

/** Night visibility of a retinitis-pigmentosa eye after full adaptation, by stage (night blindness). */
export const RP_NIGHT_VISIBILITY = [1, 0.6, 0.45, 0.32, 0.25] as const;
const RP_TAU_MIN = [1, 10, 14, 20, 28] as const;
const RP_START = 0.06;

/** Retinitis pigmentosa: starts darker, adapts slower and stops at the stage's plateau. */
export function rpVisibility(stage: 0 | 1 | 2 | 3 | 4, tMin: number): number {
  if (stage === 0) return healthyVisibility(tMin);
  const plateau = RP_NIGHT_VISIBILITY[stage];
  const tau = RP_TAU_MIN[stage];
  return RP_START + (plateau - RP_START) * (1 - Math.exp(-Math.max(0, tMin) / tau));
}
